import { render, staticRenderFns } from "./ParcialExamen.vue?vue&type=template&id=15c07398"
import script from "./ParcialExamen.vue?vue&type=script&lang=js"
export * from "./ParcialExamen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports